module.exports = __webpack_public_path__ + "static/img/shop_img04.a4ac2cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/integralshop/shop_img04.png
// module id = gE67
// module chunks = 174